import Cookies from "js-cookie";

// Single source of truth for reading/writing/removing the auth token.
// Token lives in a client-managed cookie instead of localStorage/sessionStorage
// so it is available to every tab of the same browser session
const COOKIE_NAME = "realityToken";
const REMEMBER_ME_DAYS = 7;

const getCookieSecureFlag = () => window.location.protocol === "https:";

const getAuthToken = () => Cookies.get(COOKIE_NAME) || undefined;

const setAuthToken = (token, { rememberMe = false } = {}) => {
  // Always clear any existing cookie first so a session cookie and a
  // persistent cookie never coexist under the same name.
  Cookies.remove(COOKIE_NAME, { path: "/" });

  const options = {
    path: "/",
    sameSite: "Lax",
    secure: getCookieSecureFlag(),
  };

  if (rememberMe) {
    options.expires = REMEMBER_ME_DAYS;
  }
  // Omitting `expires` creates a session cookie that lives until the
  // browser process closes, and is shared across all tabs in the meantime.

  Cookies.set(COOKIE_NAME, token, options);
};

const removeAuthToken = () => {
  Cookies.remove(COOKIE_NAME, { path: "/" });
};

// One-time cleanup of the old localStorage/sessionStorage token so no
// legacy auth storage remains after the cookie migration.
const purgeLegacyAuthStorage = () => {
  localStorage.removeItem("realityToken");
  sessionStorage.removeItem("realityToken");
};

export { getAuthToken, setAuthToken, removeAuthToken, purgeLegacyAuthStorage, getCookieSecureFlag };
